import { render, staticRenderFns } from "./FormWelcomeMessageBlock.vue?vue&type=template&id=1b431b30"
import script from "./FormWelcomeMessageBlock.vue?vue&type=script&lang=js"
export * from "./FormWelcomeMessageBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports